import { axiosInstance } from '../initialization';

import ServerUtil from '../utils/server';
import PreferencesData from '../../data/preferences';

import AuthService from './auth';

async function request(method, uri, data = {}, headers = {}) {
  if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';

  try {
    const response = await axiosInstance({
      method,
      url: `${ServerUtil.getBaseUrl()}${uri}`,
      data,
      headers,
    });
    if (response && response.data) {
      if (response.data.success) return response.data.data;
      return response.data;
    }
    return response;
  } catch (err) {
    throw err;
  }
}

async function requestBlob(method, uri, data = {}, headers = {}) {
  if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';

  try {
    const response = await axiosInstance({
      method,
      url: `${ServerUtil.getBaseUrl()}${uri}`,
      data,
      headers,
      responseType: 'blob',
    });

    if (response && response.data) {
      if (response.data.success) return response.data.data;
      return response.data;
    }

    return response;
  } catch (err) {
    throw err;
  }
}

function publicHeader(header = {}) {
  header.Authorization = `Basic ${PreferencesData.header.basic}`;
  header['content-type'] = 'application/x-www-form-urlencoded';
  return header;
}

function urlencodedTrans(data) {
  const str = [];
  const keys = Object.keys(data);
  keys.forEach((key) => { str.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`); });
  return str.join('&');
}

async function getRest(uri, header) {
  return request('get', uri, {}, header);
}

async function postRest(uri, data, header) {
  return request('post', uri, urlencodedTrans(data), publicHeader(header));
}

async function postRestNotTrans(uri, data, header) {
  return request('post', uri, data, publicHeader(header));
}

function authenticatedHeader(header = {}) {
  const auth = AuthService.get();
  if (auth) header.Authorization = `Bearer ${auth.access_token}`;
  return header;
}

async function getAuthenticated(uri, header) {
  return request('get', uri, {}, authenticatedHeader(header));
}

async function postAuthenticated(uri, data, header) {
  return request('post', uri, data, authenticatedHeader(header));
}

async function putAuthenticated(uri, data, header) {
  return request('put', uri, data, authenticatedHeader(header));
}

async function deleteAuthenticated(uri, data, header) {
  return request('delete', uri, data, authenticatedHeader(header));
}

async function getAuthenticatedBlob(uri, header) {
  return requestBlob('get', uri, {}, authenticatedHeader(header));
}

export default {
  getRest,
  postRest,
  postRestNotTrans,
  getAuthenticated,
  getAuthenticatedBlob,
  postAuthenticated,
  putAuthenticated,
  deleteAuthenticated,
};
